import React from 'react';
import { DOMParser } from './DOMParser';
const defaultParser = (node, children, index) => {
    if (!node.props) {
        node.props = {};
    }
    node.props.key = index;
    if (node.type === 'text') {
        return node.data || '';
    }
    return React.createElement(node.name, node.props, children);
};
export function traverseDom(elements, processingInstructions) {
    return elements.map((element, element_index) => {
        var _a;
        const instruction = ((_a = processingInstructions === null || processingInstructions === void 0 ? void 0 : processingInstructions.find(instruction => instruction.shouldProcessNode(element))) === null || _a === void 0 ? void 0 : _a.processNode) || defaultParser;
        return instruction(element, traverseDom(element.children, processingInstructions), element_index, elements[element_index - 1], elements[element_index + 1]);
    });
}
export function convertHTMLToJSX(html, processingInstructions) {
    return traverseDom(DOMParser(html), processingInstructions);
}
const isHTMLCache = new Map();
export function isHTML(value) {
    if (typeof value !== 'string') {
        return false;
    }
    if (isHTMLCache.has(value)) {
        return isHTMLCache.get(value);
    }
    const result = /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(value);
    isHTMLCache.set(value, result);
    return result;
}
const styleCache = new Map();
export function objectToStyle(value) {
    if (!value) {
        return '';
    }
    if (styleCache.has(value)) {
        return styleCache.get(value);
    }
    const result = Object.entries(value).reduce((acc, [key, value]) => `${acc} ${key}: ${value};`, '');
    styleCache.set(value, result);
    return result;
}
